const customOrder = [
  "Smith L1",
  "Smith L2",
  "Smith L3",
  "Smith P1",
  "Smith Pro L",
  "Smith Pro P",
  "Smith Through Rail L",
  "Smith Through Rail P",
  "Customized",
  "Single Carport",
  "Double Carport",
];

export const allRoofStructure = ({
  roofData,
  roofDetail,
  check,
  pageTitle,
}) => {
  let structureData = [];

  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const roof = roofData[i];
      if (!roof.customizeStructure) {
      if (roof.structureType === "Single") {
        structureData.push({ structure: roof.mountingStructure });
      } else {
        for (let j = 0; j < roof.multipleStructure.length; j++) {
          const elem = roof.multipleStructure[j];
          structureData.push({ structure: elem.structureType });
        }
      }
      }
    }
  } else {
    if (!roofDetail.customizeStructure) {
    if (roofDetail.structureType === "Single") {
      structureData.push({ structure: roofDetail.mountingStructure });
    } else {
      for (let j = 0; j < roofDetail.multipleStructure.length; j++) {
        const elem = roofDetail.multipleStructure[j];
        structureData.push({ structure: elem.structureType });
      }
      }
    }
  }

  // Custom sorting function
  const customSort = (a, b) => {
    return customOrder.indexOf(a.structure) - customOrder.indexOf(b.structure);
  };
  structureData.sort(customSort);

  // Custom Remove Duplicate
  structureData = customRemoveDuplicate(structureData, pageTitle);

  return structureData;
};

export const alignPanelData = ({ roofData, roofDetail, check }) => {
  let structureData = [];

  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const roof = roofData[i];
      structureData.push({ module: roof.module, moduleType: roof.moduleType });
    }
  } else {
    structureData.push({
      module: roofDetail.module,
      moduleType: roofDetail.moduleType,
    });
  }

  // Custom Remove Duplicate
  structureData = customRemoveDuplicatePanel(structureData);

  return structureData;
};

const customRemoveDuplicate = (value, pageTitle) => {
  let uniqueStructureData = value.filter((item, index, self) => {
    if (
      item.structure === "Customized" ||
      item.structure === "Single Carport" ||
      item.structure === "Double Carport"
    ) {
      return (
        self.findIndex(
          (t) =>
            t.structure === "Customized" ||
            t.structure === "Single Carport" ||
            t.structure === "Double Carport"
        ) === index
      );
    } else if (
      pageTitle === "Product Data Sheets" &&
      (item.structure === "Smith Through Rail L" ||
        item.structure === "Smith Through Rail P")
    ) {
      return (
        self.findIndex(
          (t) =>
            t.structure === "Smith Through Rail L" ||
            t.structure === "Smith Through Rail P"
        ) === index
      );
    }
    return self.findIndex((t) => t.structure === item.structure) === index;
  });
  return uniqueStructureData;
};

const customRemoveDuplicatePanel = (value) => {
  let uniqueStructureData = value.filter((item, index, self) => {
    return self.findIndex((t) => t.module === item.module) === index;
  });
  return uniqueStructureData;
};
